module.exports = __webpack_public_path__ + "static/poke-40d60f01d594f99e9bba43e063110bfa.png";